import React from 'react';
import { Pill } from '@web-for-marketing/react-ui';

interface PillProps {
    category: string;
    categoryLink: string;
    className?: string;
}

export function CategoryPill({ category, categoryLink, className }: PillProps): React.ReactElement {
    return <Pill className={className} renderLink={<a href={categoryLink}>{category}</a>} variant='secondaryOutline' />;
}
